export default "__VITE_PUBLIC_ASSET__636e734a__"